import { render } from "./NovusIntegrations.vue?vue&type=template&id=42a64d82"
import script from "./NovusIntegrations.vue?vue&type=script&lang=js"
export * from "./NovusIntegrations.vue?vue&type=script&lang=js"

import exportComponent from "/opt/novus-cloud-ui/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__